import React from 'react'
import { t } from 'i18n'

// The ✕ in a react-modal's top-right corner
const ModalCloseButton = ({ onClick }) => (
  <button type='button' className='modal-close' aria-label={t('close')} onClick={onClick}>
    <i className='fa fa-close fa-lg' aria-hidden='true' />
  </button>
)

export default ModalCloseButton
